import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const minimization = createCrudVuexModule({
  namespaced: true,
  path: "/minimization",
  state: {
    isCollectMinimizationLoading: false,
    isTransferMinimizationLoading: false,

    isUpdating: false,

    collectPagination: undefined,
    transferPagination: undefined,
  },
  getters: {
    isCollectMinimizationLoading: (state) => state.isCollectMinimizationLoading,
    isTransferMinimizationLoading: (state) => state.isTransferMinimizationLoading,

    isUpdating: (state) => state.isUpdating,

    collectPagination: (state) => state.collectPagination,
    transferPagination: (state) => state.transferPagination,
  },
  mutations: {
    isCollectMinimizationLoading: (state, value) => (state.isCollectMinimizationLoading = value),
    isTransferMinimizationLoading: (state, value) => (state.isCollectMinimizationLoading = value),

    isUpdating: (state, value) => (state.isUpdating = value),

    transferPagination: (state, value) => (state.transferPagination = value),
    collectPagination: (state, value) => (state.collectPagination = value),
  },
  actions: {
    async fetchCollectMinimization({ commit }, pagination) {
      commit("isCollectMinimizationLoading", true);
      try {
        const response = await rest.post(`/minimization/collect/paginate`, pagination);
        commit("collectPagination", response.data);
        return response;
      } finally {
        commit("isCollectMinimizationLoading", false);
      }
    },
    async fetchTransferMinimization({ commit }, pagination) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`/minimization/transfer/paginate`, pagination);
        commit("transferPagination", response.data);
        return response;
      } finally {
        commit("isTransferMinimizationLoading", false);
      }
    },

    async updateDatasourceCollectMinimization({ commit }, payload) {
      commit("isUpdating", true);
      try {
        return rest.put(`/minimization/collect/process-datasource`, payload);
      } finally {
        commit("isUpdating", false);
      }
    },

    async approveDatasourceCollectMinimization({ commit }, id) {
      commit("isUpdating", true);
      try {
        return rest.get(`/minimization/collect/process-datasource/${id}/approve`);
      } finally {
        commit("isUpdating", false);
      }
    },

    async updateDatasourceTransferMinimization({ commit }, payload) {
      commit("isUpdating", true);
      try {
        return rest.put(`/minimization/transfer/process-datasource`, payload);
      } finally {
        commit("isUpdating", false);
      }
    },

    async approveDatasourceTransferMinimization({ commit }, { id, organizationThirdPartyId }) {
      commit("isUpdating", true);
      try {
        return rest.get(`/minimization/transfer/process-datasource/${id}/${organizationThirdPartyId}/approve`);
      } finally {
        commit("isUpdating", false);
      }
    },

    //////

    async updateDataCollectMinimization({ commit }, payload) {
      commit("isUpdating", true);
      try {
        return rest.put(`/minimization/collect/datasource-data`, payload);
      } finally {
        commit("isUpdating", false);
      }
    },

    async approveDataCollectMinimization({ commit }, id) {
      commit("isUpdating", true);
      try {
        return rest.get(`/minimization/collect/datasource-data/${id}/approve`);
      } finally {
        commit("isUpdating", false);
      }
    },

    async updateDataTransferMinimization({ commit }, payload) {
      commit("isUpdating", true);
      try {
        return rest.put(`/minimization/transfer/datasource-data`, payload);
      } finally {
        commit("isUpdating", false);
      }
    },

    async approveDataTransferMinimization({ commit }, { id, organizationThirdPartyId }) {
      commit("isUpdating", true);
      try {
        return rest.get(`/minimization/transfer/datasource-data/${id}/${organizationThirdPartyId}/approve`);
      } finally {
        commit("isUpdating", false);
      }
    },

    ///////

    async updateDatasubjectTransferMinimization({ commit }, payload) {
      commit("isUpdating", true);
      try {
        return rest.put(`/minimization/transfer/data-datasubject`, payload);
      } finally {
        commit("isUpdating", false);
      }
    },

    async approveDatasubjectTransferMinimization({ commit }, { id, organizationThirdPartyId }) {
      commit("isUpdating", true);
      try {
        return rest.get(`/minimization/transfer/data-datasubject/${id}/${organizationThirdPartyId}/approve`);
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
